import rootReducer from '../reducer/index.js';
import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({ reducer: rootReducer })

export default store;